import { useId, useRef } from "react";
import Button from "./Button";
import Dialog from "./Dialog";
import Field from "./Field";
import { TextInput } from "./FormControls";

export default function TextPromptDialog({
  open,
  onClose,
  onConfirm,
  title,
  eyebrow,
  label,
  value,
  onChange,
  placeholder,
  confirmLabel = "저장",
  busy = false,
  error = "",
}) {
  const formId = useId();
  const inputId = useId();
  const inputRef = useRef(null);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      eyebrow={eyebrow}
      size="sm"
      busy={busy}
      initialFocusRef={inputRef}
      footer={(
        <>
          <Button variant="secondary" size="large" type="button" onClick={onClose} disabled={busy}>취소</Button>
          <Button size="large" type="submit" form={formId} loading={busy}>{confirmLabel}</Button>
        </>
      )}
    >
      <form
        id={formId}
        className="ds-text-prompt-form"
        onSubmit={(event) => {
          event.preventDefault();
          onConfirm();
        }}
      >
        <Field id={inputId} label={label} required error={error}>
          <TextInput
            ref={inputRef}
            id={inputId}
            value={value}
            onChange={(event) => onChange(event.target.value)}
            placeholder={placeholder}
            disabled={busy}
            autoComplete="off"
          />
        </Field>
      </form>
    </Dialog>
  );
}
